import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconChevronRight from '@spothero/icons/chevron-right';
import Link from 'router/Link';

const Breadcrumb = ({label, link, active, children, className}) => {
    const classes = classNames('Breadcrumb', {active}, className);
    const labelMarkup = active ? (
        label
    ) : link ? (
        <Link to={link}>{label}</Link>
    ) : null;

    return (
        <li className={classes}>
            <IconChevronRight />
            {children ? children : <span>{labelMarkup}</span>}
        </li>
    );
};

Breadcrumb.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    link: PropTypes.string,
    active: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.arrayOf(PropTypes.node),
    ]),
};

export default Breadcrumb;
